const { h, render, Component } = require('preact');
const Web2018Helper = require('../../../helper')

class PurchaseDate extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.orderDetails && this.props.orderDetails.purchasedAtshortDatetimeStr){
      return (
        <tr>
          <td>{I18n.translate("js.modules.web_2018.purchase_date")}:</td>
          <td>{Web2018Helper.getDateStringWithDay(this.props.orderDetails.purchasedAtshortDatetimeStr)}</td>
        </tr>
      );
    }
    return null;
  }
}
module.exports = PurchaseDate
